import { Component, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UIStore } from '@easihub/ngx';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  imports: [
    MatProgressSpinnerModule
  ],
  host: {
    class: 'fixed grid h-screen w-screen bg-surface place-content-center justify-items-center',
    '[class.hidden]': '!showSplashScreen()'
  }
})
export class SplashComponent {
  private readonly ui = inject(UIStore);

  protected readonly showSplashScreen = this.ui.showSplashScreen;
}